import { useState } from '#imports'
import { onMounted } from 'vue'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import {
  CLICKED_PRODUCT_STATE_KEY,
  type ClickedProductCardData,
} from './useProductClickStore'

export function useProductDesyncValidator(
  listingId: string,
  price: string,
  isOutOfStock: boolean,
): void {
  const logger = useLogger()
  const clickedProductCardData = useState<ClickedProductCardData | null>(
    CLICKED_PRODUCT_STATE_KEY,
    () => null,
  )

  onMounted(() => {
    if (!clickedProductCardData.value) return

    const commonFields = {
      cardListingId: clickedProductCardData.value.listingId,
      pdpListingId: listingId,
      cardPrice: clickedProductCardData.value.price,
      pdpPrice: price,
      referrerRoute: clickedProductCardData.value.referrerRoute,
      cardCategory: clickedProductCardData.value.category,
      owners: ['bot-squad-search-and-recommendation-front'],
    }

    if (isOutOfStock) {
      logger.info('[S&R][ProductPage] Desync detected', {
        type: 'stock',
        ...commonFields,
      })
      clickedProductCardData.value = null

      return
    }

    if (parseFloat(clickedProductCardData.value.price) !== parseFloat(price)) {
      logger.info('[S&R][ProductPage] Desync detected', {
        type: 'price',
        ...commonFields,
      })
      clickedProductCardData.value = null

      return
    }

    if (clickedProductCardData.value.listingId !== listingId) {
      logger.info('[S&R][ProductPage] Desync detected', {
        type: 'listing',
        ...commonFields,
      })
      clickedProductCardData.value = null

      return
    }

    logger.info('[S&R][ProductPage] No desync detected', {
      type: 'success',
      ...commonFields,
    })
    clickedProductCardData.value = null
  })
}
